/* Vicca — pills de categoría con filtrado Ajax (feedback Victor 1 oct, ítem 12).
   Sustituye el grid vía Section Rendering API sin recargar ni saltar arriba;
   enlaces reales como fallback sin JS. */
class ViccaPlpPills extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event) {
    const link = event.target.closest('.vicca-plp-intro__pill');
    if (!link || !link.href) return;

    const gridSelector = this.dataset.gridSelector;
    const gridWrapper = gridSelector ? document.querySelector(gridSelector) : null;
    if (!gridWrapper || !gridWrapper.id) return; // deja el enlace normal como fallback

    event.preventDefault();
    if (this.loading) return;

    const sectionId = gridWrapper.id.replace('shopify-section-', '');
    const url = new URL(link.href, window.location.origin);
    url.searchParams.set('section_id', sectionId);

    this.loading = true;
    gridWrapper.classList.add('vicca-plp-pills--loading');

    fetch(url.toString())
      .then((response) => {
        if (!response.ok) throw new Error('Network error');
        return response.text();
      })
      .then((html) => {
        // La Section Rendering API (?section_id=) devuelve el fragmento de la
        // sección, no el div#shopify-section-… que lo envuelve: se sustituye
        // directamente el contenido del wrapper existente.
        gridWrapper.innerHTML = html;

        this.querySelectorAll('.vicca-plp-intro__pill').forEach((pill) => {
          pill.classList.toggle('vicca-plp-intro__pill--active', pill === link);
        });

        window.history.pushState({}, '', link.href);
        this.updateIntro(link.href);

        const rect = gridWrapper.getBoundingClientRect();
        const isVisible = rect.top >= 0 && rect.top < window.innerHeight * 0.6;
        if (!isVisible) {
          gridWrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      })
      .catch(() => {
        window.location.href = link.href; // fallback si falla el fetch
      })
      .finally(() => {
        this.loading = false;
        gridWrapper.classList.remove('vicca-plp-pills--loading');
      });
  }
}

ViccaPlpPills.prototype.updateIntro = function (href) {
  // Título y descripción de la colección elegida (misma sección, render por API).
  const introSection = this.closest('.shopify-section');
  if (!introSection || !introSection.id) return;
  const url = new URL(href, window.location.origin);
  url.searchParams.set('section_id', introSection.id.replace('shopify-section-', ''));
  fetch(url.toString())
    .then((r) => (r.ok ? r.text() : Promise.reject()))
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newTitle = doc.querySelector('.vicca-plp-intro__title');
      const oldTitle = this.closest('.shopify-section').querySelector('.vicca-plp-intro__title');
      if (newTitle && oldTitle) oldTitle.innerHTML = newTitle.innerHTML;
      const newDesc = doc.querySelector('.vicca-plp-intro__description');
      const oldDesc = this.closest('.shopify-section').querySelector('.vicca-plp-intro__description');
      if (newDesc && oldDesc) oldDesc.innerHTML = newDesc.innerHTML;
      else if (newDesc && !oldDesc && oldTitle) oldTitle.insertAdjacentElement('afterend', newDesc);
      else if (!newDesc && oldDesc) oldDesc.remove();
      if (newTitle) document.title = document.title.replace(/^[^–]+–/, newTitle.textContent.trim() + ' –');
    })
    .catch(() => {});
};

customElements.define('vicca-plp-pills', ViccaPlpPills);
